import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BoundaryTools from "./BoundaryTools";
import { useLocation } from "react-router-dom";

interface SearchProps {
  rightOffset: number;
}

const SearchContainer = styled.div<SearchProps>`
  position: absolute;
  top: 0;
  z-index: 100;
  top: 10px;
  right: ${(props) => props.rightOffset}px;
`;

const SearchToolbar = () => {
  const searchRef = useRef<HTMLDivElement | null>(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [sidebarRightOffset, setSidebarRightOffset] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (searchRef.current) {
      const current = searchRef.current;
      const screenHalf = screenWidth / 2;
      const searchHalf = current.offsetWidth / 2;
      const right = screenHalf - searchHalf;
      setSidebarRightOffset(right);
    }
  }, [screenWidth]);

  return (
    <>
      {location.pathname === "/" && (
        <SearchContainer rightOffset={sidebarRightOffset} ref={searchRef}>
          <BoundaryTools />
        </SearchContainer>
      )}
    </>
  );
};

export default SearchToolbar;
